import React, { Component } from "react";
import { Button, Glyphicon, ButtonToolbar } from "react-bootstrap";
import HabitRow from "./HabitRow";
import CreateHabitRow from "./CreateHabitRow";

import "./AllHabits.css";

export default class AllHabits extends Component {

  constructor(props) {
    super(props);

    this.daysOfWeek = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
    this.monthsOfYear = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
    this.handleTableHovered = this.handleTableHovered.bind(this);
    this.handleEditHistoryHovered = this.handleEditHistoryHovered.bind(this);
    this.handleLeftArrowHovered = this.handleLeftArrowHovered.bind(this);
    this.handleRightArrowHovered = this.handleRightArrowHovered.bind(this);
    this.handleFirstCellHovered = this.handleFirstCellHovered.bind(this);

    this.handleKeyPressed = this.handleKeyPressed.bind(this);
    this.handleDragDrop = this.handleDragDrop.bind(this);
    this.handleDrag = this.handleDrag.bind(this);
    this.habitRows = this.habitRows.bind(this);

    this.state = {
      isEditMode: false,
      isTableHovered: false,
      isEditHistoryHovered: false,
      isLeftArrowHovered: false,
      isRightArrowHovered: false,
      isFirstCellHovered: false,
    };
  }

  handleKeyPressed(event) {
    if (event.keyCode === 37) {
      this.props.handleLeft();
    }
    if (event.keyCode === 39) {
      this.props.handleRight();
    }
    if (event.keyCode === 32) {
      this.props.handleTodayRight();
    }
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyPressed, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyPressed, false);
  }

  handleDragDrop(habitId) {
    this.setState({
      habitDragged: null,
    });
    this.props.updateHabitOrder(this.props.user.habitOrder);
  }


  handleDrag(habitId) {
    this.setState({
      habitDragged: habitId,
      habitDraggedFrom: habitId
    });
  }

  handleEditClick() {
    this.setState({
      isEditMode: !this.state.isEditMode
    })
  }

  handleTableHovered() {
    this.setState({
      isTableHovered: !this.state.isTableHovered
    });
  }

  handleEditHistoryHovered() {
    this.setState({
      isEditHistoryHovered: !this.state.isEditHistoryHovered
    });
  }

  handleLeftArrowHovered() {
    this.setState({
      isLeftArrowHovered: !this.state.isLeftArrowHovered
    });
  }

  handleRightArrowHovered() {
    this.setState({
      isRightArrowHovered: !this.state.isRightArrowHovered
    });
  }

  handleFirstCellHovered() {
    // this.setState({
    //   isFirstCellHovered: !this.state.isFirstCellHovered
    // });
  }

  render() {
    return (
      <table className="habitTable"
        onMouseEnter={ this.handleTableHovered }
        onMouseLeave={ this.handleTableHovered }
        >
        <thead className="labelRow">
          { this.labelRow() }
        </thead>
        <tbody className="habitRows">
            { this.firstRow() }
            { this.habitRows() }
        </tbody>
      </table>
    );
  }

  labelRow() {
    return (
      <tr>
        <th
          className="editHistoryLabel"
          >
            {
              this.state.isEditHistoryHovered ?
               "edit history"
               :
               null
            }
         </th>
        { this.labelRowCols() }
      </tr>
    );
  }


  firstRow() {
    return (
      <tr className="firstRow">
        <th
        onMouseEnter={ this.handleFirstCellHovered }
        onMouseLeave={ this.handleFirstCellHovered }
        >
          { this.state.isFirstCellHovered ?
            <div
              className="firstCellIcons"
              >
            </div>
              :
            null
          }
         </th>
        { this.dayLabels() }
      </tr>
    );
  }

  isSameDate(x , y) {
    if (x.getFullYear() === y.getFullYear() &&
        x.getMonth() === y.getMonth() &&
        x.getDate() === y.getDate()) {
          return true;
    }
    return false;
  }


  labelRowCols() {
    var dayColumns = [];

    for (var i = 1; i <= this.props.numDays; i++) {
      var hoverStyle = {
        color: '#555'
      }
      if (i == 1) {
        dayColumns.push(
          <th onClick={ this.props.handleLeft } onMouseEnter={ this.handleLeftArrowHovered } onMouseLeave={ this.handleLeftArrowHovered } >
            <div className="leftBox">
              <Glyphicon style={ this.state.isLeftArrowHovered ? hoverStyle : null } className="left" glyph="triangle-left" />
            </div>
          </th>
        )
      } else if (i == this.props.numDays) {
        dayColumns.push(
          <th onClick={ this.props.handleRight } onMouseEnter={ this.handleRightArrowHovered } onMouseLeave={ this.handleRightArrowHovered } >
            <div className="rightBox">
              <Glyphicon style={ this.state.isRightArrowHovered ? hoverStyle : null } className="right" glyph="triangle-right" />
            </div>
          </th>
        )
      } else {
        dayColumns.push(
          <th></th>
        )
      }
    }
    return dayColumns;
  }

  dayLabels() {
    var dayColumns = [];
    for (var i = 1; i <= this.props.numDays; i++) {
      var colDate = new Date(this.props.startDate);
      colDate.setDate(colDate.getDate() + i);
      var dayOfWeek = this.daysOfWeek[colDate.getDay()];
      var monthOfYear = this.monthsOfYear[colDate.getMonth()];
      var dateOfMonth = colDate.getDate();

      var divStyle = {
        'backgroundColor': 'rgba(78, 78, 78, 0.85)',
        'color': 'white',
        'position': 'fixed',
        'fontWeight': '800',
        'width': '70px'
      }
      var colDate = new Date(this.props.startDate);
      colDate.setDate(colDate.getDate() + i);
      var isSameDate = this.isSameDate(colDate, new Date());
      var todayLabel = isSameDate ? (<div style={ divStyle } className="today">TODAY</div>) : null;
        dayColumns.push(
          <th className="days">
              <div>
                <div className="monthOfYear"> { monthOfYear } </div>
                <div className="dateOfMonth"> { dateOfMonth } </div>
                <div className="dayOfWeek"> { dayOfWeek } </div>
                { todayLabel }
              </div>
          </th>
        );
    }
    return dayColumns;
  }


  habitRows() {
     var rows = []

    for (var i = 0; i < this.props.habits.length; i++) {
      rows.push(<HabitRow
         habit={ this.props.habits[i] }
         numDays={ this.props.numDays}
         loadHabits={ this.props.loadHabits }
         startDate={ this.props.startDate }
         isEditMode={this.props.isEditMode }
         handleDrag={ this.handleDrag }
         handleDragDrop={ this.handleDragDrop }
         habitDragged={ this.state.habitDragged }
         isTableHovered={ this.state.isTableHovered }
         mouseIsDown={ this.props.mouseIsDown }
         handleMouse={this.props.handleMouse}
         handleHoverMove={ this.props.handleHoverMove }
         >
         </HabitRow>);
    }
    rows.push(<CreateHabitRow></CreateHabitRow>);
    return rows;
  }
}



// WEBPACK FOOTER //
// ./src/containers/AllHabits.js